import {Category} from '@wix/ambassador-wix-events-web/types'
import {ISettingsGetter} from '@wix/tpa-settings'
import {ExperimentNames, LIST_DISPLAY_STRATEGY} from '@wix/wix-events-commons-statics'
import {Experiments, TFunction} from '@wix/yoshi-flow-editor'
import {TabItem} from 'wix-ui-tpa/cssVars'
import {ALL_CATEGORIES_FILTER} from '../../../../commons/constants/settings'
import {getCategoryMenuIds, getInitialCategoryId} from '../../../../commons/selectors/categories'
import settingsParams from '../../settingsParams'
import {State} from '../types/state'

export const getCategoryMenuFilterIds = (getSetting: ISettingsGetter): string[] => {
  const categoryMenuIds = getCategoryMenuIds(getSetting)
  return categoryMenuIds.filter(id => id !== ALL_CATEGORIES_FILTER)
}

export const isCategoryMenuMode = (getSetting: ISettingsGetter, experiments: Experiments): boolean => {
  if (!experiments.enabled(ExperimentNames.CategoryTabsUoU)) {
    return false
  }

  const listDisplayStrategy = getSetting(settingsParams.listDisplayStrategy) as number
  const categoryMenuIds = getCategoryMenuIds(getSetting)

  return listDisplayStrategy === LIST_DISPLAY_STRATEGY.CATEGORY_MENU && Boolean(categoryMenuIds.length)
}

export const getLoadedCategories = (state: State) => state.categories.categories

export const getMenuCategories = (state: State, getSetting: ISettingsGetter, t: TFunction): Category[] => {
  const categoryMenuIds = getCategoryMenuIds(getSetting)
  const loadedCategories = getLoadedCategories(state)

  return categoryMenuIds
    .map(categoryId => {
      if (categoryId === ALL_CATEGORIES_FILTER) {
        return {
          id: ALL_CATEGORIES_FILTER,
          name: t('categories_all'),
        } as Category
      }

      return loadedCategories.find(category => category.id === categoryId)
    })
    .filter(Boolean)
}

export const getCategoryTabItems = (state: State, getSetting: ISettingsGetter, t: TFunction): TabItem[] => {
  const categories = getMenuCategories(state, getSetting, t)

  return categories.map(category => ({
    title: category.name,
    id: category.id,
  }))
}

export const getInitialCategoryFilter = (getSetting: ISettingsGetter): string[] => {
  const initialCategoryId = getInitialCategoryId(getSetting)

  if (initialCategoryId === ALL_CATEGORIES_FILTER) {
    return getCategoryMenuFilterIds(getSetting)
  }

  return [initialCategoryId]
}

export const getInitialFetchCategoryId = (
  getSetting: ISettingsGetter,
  experiments: Experiments,
): string[] | undefined => {
  if (isCategoryMenuMode(getSetting, experiments)) {
    return getCategoryMenuFilterIds(getSetting)
  }
  return undefined
}
